import { createQuerySuggestionsPlugin } from '@algolia/autocomplete-plugin-query-suggestions'
import { createLocalStorageRecentSearchesPlugin } from '@algolia/autocomplete-plugin-recent-searches'
import type { IndexType } from '@dreamstack/search'
import { useMemo } from 'react'
import { getIndexProps } from '../lib/getIndexProps'
import { searchClient } from './searchClient'

export const useAutocompletePlugins = ({
  setSearchState,
  indexType,
}: {
  setSearchState: (state: any) => void
  indexType: IndexType
}) => {
  const { indexName, key } = getIndexProps(indexType)
  const plugins = useMemo(() => {
    if (!indexName || !key) return
    const recentSearchesPlugin = createLocalStorageRecentSearchesPlugin({
      key: key,
      limit: 3,
      transformSource({ source }) {
        return {
          ...source,
          onSelect(params) {
            console.log({ params })
            setSearchState((searchState: any) => ({
              ...searchState,
              query: params.item.label,
            }))
          },
        }
      },
    })

    const recent = recentSearchesPlugin.data
    const getSearchParams = recent
      ? () =>
          recent.getAlgoliaSearchParams({
            hitsPerPage: 5,
          })
      : undefined

    return [
      recentSearchesPlugin,
      createQuerySuggestionsPlugin({
        searchClient,
        indexName: `${indexName}_query_suggestions`,
        getSearchParams,
        transformSource({ source }) {
          return {
            ...source,
            onSelect(params) {
              setSearchState((searchState: any) => ({
                ...searchState,
                query: params.item.query,
              }))
            },
          }
        },
      }),
    ]
  }, [indexName, key, setSearchState])
  return plugins
}
